// this file is automatically generated by git.version.ts script
/* tslint:disable */
export const versions = {commitDateTime: '2026-07-30T13:37:30+0200', version: '4.7.1', revision: 'ea16cbfa9', branch: 'HEAD'};
 